function splitTextIntoLines(element) {
  const wrapper = document.createElement("span");
  wrapper.className = "animated-line-wrapper";
  const lineContent = document.createElement("span");
  for (
    lineContent.className = "animated-line",
      lineContent.setAttribute("data-line", 0);
    element.firstChild;

  )
    lineContent.appendChild(element.firstChild);
  return wrapper.appendChild(lineContent), element.appendChild(wrapper), 1;
}

function triggerAnimation(lines) {
  lines.forEach((line, index) => {
    setTimeout(() => {
      line.classList.add("animated-line--visible"),
        (line.style.cssText = "opacity: 1; transform: translateY(0);"),
        line.setAttribute("data-line", index);
    }, index * 400);
  });
}
function initAnimatedText() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const container = entry.target;
          const allLines = container.querySelectorAll(".animated-line");
          if (allLines.length > 0) {
            triggerAnimation(allLines);
            observer.unobserve(container);
          }
        }
      });
    },
    { threshold: 0.75, rootMargin: "0px" }
  );

  document.querySelectorAll(".section").forEach((container) => {
    const textElements = container.querySelectorAll(
      ".text-block--has-animated-text p, .text-block--has-animated-text h2, .text-block--has-animated-text h3"
    );
    if (textElements.length === 0) return;

    textElements.forEach((element) => {
      if (element.querySelector(".animated-line-wrapper")) return;
      splitTextIntoLines(element);
    });

    const allLines = container.querySelectorAll(".animated-line");
    if (allLines.length > 0) {
      observer.observe(container);
    }
  });
}
document.fonts && document.fonts.ready
  ? document.fonts.ready.then(initAnimatedText)
  : document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", initAnimatedText)
  : initAnimatedText();
